import { render } from "./ItemDetail.vue?vue&type=template&id=d56e4b3a&scoped=true&ts=true"
import script from "./ItemDetail.vue?vue&type=script&lang=ts"
export * from "./ItemDetail.vue?vue&type=script&lang=ts"

import "./ItemDetail.vue?vue&type=style&index=0&id=d56e4b3a&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3320913318/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d56e4b3a"]])

export default __exports__